import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import { getSpeakerDetails } from '../utils/services';
import talksMock from '../mocks/talks';
import speakersMock from '../mocks/speakers';

const { Consumer, Provider } = React.createContext();

const SpeakerDetailsProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [speakers, setSpeakers] = useState([]);
  const [talks, setTalks] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const loadSpeakerDetails = async speakerId => {
    setIsLoading(true);
    // const details = await getSpeakerDetails(speakerId);
    // setSpeakers(details.speakers);
    // setTalks(details.talks);
    setSpeakers(speakersMock);
    setTalks(talksMock);
    setIsLoading(false);
  };

  return (
    <Provider
      value={{
        isLoading,
        speakers,
        talks,
        loadSpeakerDetails
      }}>
      {children}
    </Provider>
  );
};

SpeakerDetailsProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export { SpeakerDetailsProvider, Consumer as SpeakerDetailsConsumer };
